import graphqlClient from "../../../apollo";

class ClienteProvider {

    findCliente(id) {
        return graphqlClient.query({
            query: require('./gql/clienteFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchClientes() {
        return graphqlClient.query({
            query: require('./gql/clienteFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateClientes(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false, filters = {}) {
        return graphqlClient.query({
            query: require('./gql/clientePaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc, filters },
            fetchPolicy: "network-only"
        })
    }

    consultarArca(cuit) {
        return graphqlClient.query({
            query: require('./gql/clienteConsultarArca.graphql'),
            variables: { cuit },
            fetchPolicy: "network-only"
        })
    }

    createCliente(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/clienteCreate.graphql'),
            variables: { input: form }
        })
    }

    updateCliente(form) {
        const { id, ...input } = form;
        return graphqlClient.mutate({
            mutation: require('./gql/clienteUpdate.graphql'),
            variables: { id, input }
        })
    }

    deleteCliente(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/clienteDelete.graphql'),
            variables: { id }
        })
    }

}

export default new ClienteProvider()
